import React from 'react';
import cx from 'clsx';
import * as css from './PageHeader.module.scss';

export type PageHeaderProps = {
    title?: string;
    theme?: 'dark' | 'g10';
    tabs?: any[];
};
export function PageHeader({ title, theme, tabs = [] }: PageHeaderProps) {
    return (
        <div className={cx(css.pageHeader, tabs.length && css.withTabs, theme === 'dark' && css.darkMode)}>
            <div className="cds--grid">
                <div className="cds--row">
                    <div className="cds--col-lg-12">
                        <h1 id="page-title" className={css.text} children={title} />
                    </div>
                </div>
            </div>
        </div>
    );
}
